import { RevalueTradesMetricsRequestPayload } from '@/pages/tools/RevaluationTool/types';
import { AxiosInstance } from 'axios';

export default class RevalueTradesAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async revalueTransactionValueMetrics(
    payload: RevalueTradesMetricsRequestPayload,
  ) {
    return this.client.post(
      '/v2/admin/revalue-transaction-value-metrics/',
      payload,
    );
  }

  async revalueTradesBCVA(payload: RevalueTradesMetricsRequestPayload) {
    return this.client.post('/v2/admin/revalue-transaction-bcva/', payload);
  }

  async getTaskProgress(taskId: string) {
    return this.client.get(`/v2/admin/task/${taskId}/`);
  }

  async getReportDownload(taskId: string) {
    return this.client.get(`/v2/admin/task/${taskId}/download-report-url/`);
  }
}
